// extracted by mini-css-extract-plugin
export default {"FooterHeader":"Footer_FooterHeader__HjuQm","List":"Footer_List__4WT3J","ListItem":"Footer_ListItem__Iu+vw"};